import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { IntegrationFormTypes, SettingsFormTypes } from "models/formTypes";
import { StyleEnums } from "models/enums";
import { FormHandles } from "models/propTypes/genericFormProps";
import { StripeConnectFormContainerProps } from "models/propTypes/integrationsPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import StripeConnectForm from "./stripeConnectForm";
//#endregion
import * as Yup from "yup";

const StripeConnectFormContainer: ForwardRefRenderFunction<FormHandles, StripeConnectFormContainerProps> = (
  props,
  ref
) => {
  const validationSchema = Yup.object<IntegrationFormTypes.StripeConnect>({
    useStripeConnect: Yup.boolean(),
    useStripeConnectDescription: Yup.string(),
  });

  const defaultValues: IntegrationFormTypes.StripeConnect = {
    useStripeConnect: props.isActive === true,
  };

  const handleSubmit = async (values: IntegrationFormTypes.StripeConnect) => {
    const stripeConnectAccountId = props.stripeConnectAccountId;
    const isCurrentlyConnected = props.isActive === true;

    if (values.useStripeConnect && !isCurrentlyConnected) {
      if (!props.onStripeConnectClick) {
        throw new Error("onStripeConnectClick handler is required to initiate Stripe Connect.");
      }

      await props.onStripeConnectClick();
      // Keep the row unchanged until the Stripe callback stores the connection.
    }

    if (!values.useStripeConnect && isCurrentlyConnected) {
      if (!stripeConnectAccountId) {
        throw new Error("Stripe account id is missing.");
      }

      if (!props.onStripeDisconnectClick) {
        throw new Error("onStripeDisconnectClick handler is required to disconnect Stripe.");
      }

      await props.onStripeDisconnectClick(stripeConnectAccountId);

      return props.submitResultFormatter?.({
        ...props,
        isActive: false,
        statusLabel: TranslationKeys.Integrations.NotConnected,
        statusDisplayType: StyleEnums.DisplayType.Warning,
        stripeConnectAccountId: undefined,
      } as SettingsFormTypes.IntegrationItem);
    }

    return props.submitResultFormatter?.({
      ...props,
      isActive: props.isActive,
    } as SettingsFormTypes.IntegrationItem);
  };

  return (
    <StripeConnectForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      handleSubmit={handleSubmit}
    />
  );
};

export default forwardRef(StripeConnectFormContainer);
